import * as Yup from 'yup';

export const otpVerificationSchema = Yup.object().shape({
    otp: Yup.string()
        .matches(/^\d+$/, 'OTP must contain only numbers')
        .length(6, 'Your OTP must be six digit')
        .required('Please enter your six digit OTP')
});
